import { useMemo } from 'react';

import { getColumnDefinitions } from './NetSuiteApplyList.config';
import { ApplyListColumnOptions } from './NetSuiteApplyList.types';

export const useTableDefinitions = ({
    fieldSettings,
    exchangeRate,
    activeAttachmentId,
    onSelectBill,
    onSelectAttachment,
}: ApplyListColumnOptions) => {
    const resultColumnDefinition = useMemo(
        () =>
            getColumnDefinitions({
                fieldSettings,
                exchangeRate,
                activeAttachmentId,
                onSelectBill,
                onSelectAttachment,
            }),
        [activeAttachmentId, fieldSettings, exchangeRate, onSelectBill, onSelectAttachment]
    );

    return resultColumnDefinition;
};
